/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDiploma} from '@fortawesome/pro-duotone-svg-icons';

const ReportCardIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDiploma} {...props} />
);

export default ReportCardIcon;
